exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card[data-v-6db8e4a1] .thumbnail {\n    width: 140px;\n    height: 140px;\n    left: 50%;\n    right: auto;\n}\n.card[data-v-6db8e4a1] .inner-thumbnail {\n    position: relative;\n    left: -50%;\n    right: auto;\n}\n.card[data-v-6db8e4a1] .image-thumbnail {\n    border-radius: 50% !important;\n}\n\n", ""]);

// exports
